export const top15FoodBeverageRECCs = [
    {
      arc_code: "2.1233",
      title: "Analyse flue gas for proper air:fuel ratio",
      annual_savings: 48000,
      payback_years: 1.8,
      cost_category: "medium_cost",
      description: "Optimize combustion efficiency by analyzing flue gas to maintain proper air/fuel balance, reducing excess air without risking incomplete combustion."
    },
    {
      arc_code: "2.2136",
      title: "Install and repair insulation on steam lines",
      annual_savings: 35000,
      payback_years: 0.9,
      cost_category: "low_cost",
      description: "Reduce heat losses from steam distribution systems by installing proper insulation and repairing damaged sections."
    },
    {
      arc_code: "2.2414",
      title: "Use waste heat from hot flue gases to preheat",
      annual_savings: 67500,
      payback_years: 2.8,
      cost_category: "high_cost",
      description: "Recover waste heat from flue gases using heat exchangers to preheat combustion air, feedwater, or process fluids."
    },
    {
      arc_code: "2.2437",
      title: "Recover waste heat from equipment",
      annual_savings: 52000,
      payback_years: 2.1,
      cost_category: "medium_cost",
      description: "Capture and utilize waste heat from industrial equipment and processes to reduce overall energy consumption."
    },
    {
      arc_code: "2.2511",
      title: "Insulate bare equipment",
      annual_savings: 28500,
      payback_years: 1.2,
      cost_category: "low_cost",
      description: "Install insulation on uninsulated equipment surfaces to reduce heat losses and improve energy efficiency."
    },
    {
      arc_code: "2.3212",
      title: "Optimise plant power factor",
      annual_savings: 18700,
      payback_years: 1.6,
      cost_category: "medium_cost",
      description: "Improve electrical power factor through capacitor installation and power factor correction to reduce electrical demand charges."
    },
    {
      arc_code: "2.4111",
      title: "Utilise energy-efficient belts and other improved drive systems",
      annual_savings: 15200,
      payback_years: 1.4,
      cost_category: "low_cost",
      description: "Replace standard V-belts with high-efficiency belts and optimize drive system design for improved power transmission."
    },
    {
      arc_code: "2.4133",
      title: "Use most efficient type of electric motors",
      annual_savings: 42800,
      payback_years: 2.3,
      cost_category: "medium_cost",
      description: "Replace standard motors with premium efficiency motors and right-size motors for their applications."
    },
    {
      arc_code: "2.4146",
      title: "Use adjustable frequency drive or multiple speed motors",
      annual_savings: 73600,
      payback_years: 1.8,
      cost_category: "medium_cost",
      description: "Install variable frequency drives (VFDs) or multi-speed motors to match motor speed with load requirements."
    },
    {
      arc_code: "2.4221",
      title: "Install compressor air intakes in coolest location",
      annual_savings: 8900,
      payback_years: 0.7,
      cost_category: "low_cost",
      description: "Relocate compressor air intakes to draw cooler ambient air, reducing compression energy requirements."
    },
    {
      arc_code: "2.4231",
      title: "Eliminate unnecessary compressed air uses",
      annual_savings: 22500,
      payback_years: 0.8,
      cost_category: "low_cost",
      description: "Implement policies and controls to eliminate non-essential compressed air usage for cooling, sweeping, and other applications."
    },
    {
      arc_code: "2.4236",
      title: "Eliminate leaks in inert gas and compressed air lines/valves",
      annual_savings: 31200,
      payback_years: 1.1,
      cost_category: "low_cost",
      description: "Systematically identify and repair leaks in compressed air and inert gas systems to reduce energy waste."
    },
    {
      arc_code: "2.4239",
      title: "Eliminate or reduce compressed air usage",
      annual_savings: 44800,
      payback_years: 2.6,
      cost_category: "medium_cost",
      description: "Replace compressed air applications with more efficient alternatives where technically feasible."
    },
    {
      arc_code: "2.7135",
      title: "Install occupancy sensors",
      annual_savings: 12400,
      payback_years: 1.3,
      cost_category: "low_cost",
      description: "Install occupancy sensors to automatically control lighting in areas with intermittent occupancy."
    },
    {
      arc_code: "2.7142",
      title: "Utilise higher efficiency lamps and/or ballasts",
      annual_savings: 25600,
      payback_years: 1.5,
      cost_category: "low_cost",
      description: "Replace inefficient lighting with LED systems and high-efficiency ballasts to reduce lighting energy consumption."
    }
  ];
